import { Box, FormControlLabel, Grid, Switch } from "@mui/material";
import CustomButton from "../../../components/common/button/CustomButton";
import Popup from "../../../components/common/model/Popup";
import React, { useEffect, useMemo, useRef, useState } from "react";
import FormField from "../../../components/common/FormField";
import { filterFields } from "./leadAllFields";
import { useSelector, useDispatch } from "react-redux";
import { getAccountNameListAction, getAllLeadListAction, setLeadListAction } from "../../../store/reducers/leadSlice";
import { getAllSubUserAction } from "../../../store/reducers/subUserSlice";

interface ManageFilterProps {
  open: boolean;
  setOpenFilter?: any;
  onHide: () => void; // Define the 'onHide' prop
  title: string;
  selectLead?: any;
  action?: any;
  setSelectedOrderBy?:any;
  setSelectedOrderIn?:any;
  setFormData?:any;
  formData?: any;
  value?:any;
  filterLeads?: any;
   // Add to ManageFilterProps:
onApplyFilter?: (sortValues: { orderBy: string; orderIn: string; accountName?: string;b2bAccounts?: boolean; salesPersonId?: string }) => void;
}

interface FilterOption {
  page: number;
  limit: number;
  orderBy: string;
  orderIn: string;
  search: string;
  filterStatus: string;
  accountName?: string;
  salesPersonId?: string;
  b2bAccounts?: boolean;
 
}

// Define valid keys for formData and filterOption
type FormDataKeys = 'orderBy' | 'orderIn';

const ManageFilter: React.FC<ManageFilterProps> = ({ open, onHide, title, setSelectedOrderBy, setSelectedOrderIn, formData, setFormData, value, setOpenFilter, filterLeads,onApplyFilter }) => {
  const [fullWidth] = useState(true);
  const [maxWidth] = useState<"sm" | "xs" | "md" | "lg" | "xl" | false>("sm");
  const didApplyRef = useRef(false);
  console.log("filterLeads-24", filterLeads);
  const dispatch = useDispatch();
  const { isLeadListSuccess,accountNamesList } = useSelector(
    (state: any) => state.lead
  );
  const { user } = useSelector((state: any) => state.user);
  const { users } = useSelector((state: any) => state.subUser);
  const [filterOption, setFilterOption] = useState<FilterOption>({
    page: 1,
    limit: 10,
    orderBy: "created_at",
    orderIn: "DESC",
    search: "",
    filterStatus: filterLeads ? filterLeads?.filterStatus || "" : "",
    accountName: filterLeads?.accountName || "",
    salesPersonId: filterLeads?.salesPersonId || "",
    b2bAccounts: filterLeads?.b2bAccounts ?? formData?.b2bAccounts ?? false,
  });

  useEffect(()=>{
     dispatch(getAllSubUserAction({ status: "" }));
     dispatch(getAccountNameListAction());
    },[dispatch])
  const orderByMap: Record<string, string> = {
    "Follow-up date": "follow_up_date",
    "Entry date": "created_at",
    "Moving date": "moving_on_date",
    "Last update date": "updated_at",
  };

  const orderInMap: Record<string, string> = {
    "Ascending": "ASC",
    "Descending": "DESC",
   
  };

  // Add this after your existing useEffects
useEffect(() => {
  if (!filterLeads) return;

  setFormData((prev: any) => ({
    ...prev,
    orderBy: orderByMap[filterLeads.orderBy] || "",
    orderIn: orderInMap[filterLeads.orderIn] || "",
    accountName: filterLeads.accountName || "",
    salesPersonId: filterLeads.salesPersonId || "",
    b2bAccounts: filterLeads.b2bAccounts ?? false,
  }));
}, []); // runs once on mount — modal remounts every open so this is always fresh

  // Ensure id is typed as FormDataKeys
  const onChangeAction = (event: React.ChangeEvent<HTMLInputElement>) => {
    const { id, value } = event.target;

    // Ensure id has the type FormDataKeys to avoid implicit 'any' type
    const fieldId = id as FormDataKeys;

    const mappedOrderBy = orderByMap[value] || value;
    const mappedOrderIn = orderInMap[value] || value;

    setFormData((prev:any) => ({
      ...prev,
      [fieldId]: value,
    }));

    // Set the selected display name in selectedOrderBy (use original value)
  if (fieldId === "orderBy") {
    setSelectedOrderBy(value); // store the name selected by the user
  }
// Set the selected display name in selectedOrderIn (use original value)
  if(fieldId === "orderIn") {
    setSelectedOrderIn(value); // store the name selected order
  }

    setFilterOption((prev) => ({
      ...prev,
      [fieldId]: fieldId === "orderBy" ? mappedOrderBy :fieldId === "orderIn" ? mappedOrderIn : value,
    }));
  };

  const handleB2BAccountsChange = (
    event: React.ChangeEvent<HTMLInputElement>,
  ) => {
    const b2bAccounts = event.target.checked;
    setFormData((previous: any) => ({ ...previous, b2bAccounts }));
    setFilterOption((previous) => ({ ...previous, b2bAccounts }));
  };

  const submitHandler = () => {
    didApplyRef.current = true;

     // Update LeadList's filterOption so search bar changes don't wipe the sort
  if (onApplyFilter) {
    onApplyFilter({
      orderBy: filterOption.orderBy,
      orderIn: filterOption.orderIn,
      accountName: filterOption.accountName,
      b2bAccounts: filterOption.b2bAccounts,
      salesPersonId: filterOption.salesPersonId,
    });
  }

    let roleType = user?.user?.roles;
    if (!roleType?.includes("Surveyor")) {
      if (value === "0") {
        roleType = "Admin"; // Set roleType to Admin when the first tab is selected
      } else {
        roleType = "Surveyor";
      }
    }
    dispatch(getAllLeadListAction({ ...filterOption, roleType }));
  };

  
  const clearHandler = () => {
    const clearedFilter: FilterOption = {
      page: 1,
      limit: 10,
      orderBy: "created_at",
      orderIn: "DESC",
      search: "",
      filterStatus:filterLeads? filterLeads?.filterStatus || "" : "",
       accountName: "",    // ✅ truly clear
    salesPersonId: "",  // ✅ truly clear
    b2bAccounts: false,
    };

    setFilterOption(clearedFilter);
    setFormData({
      orderBy: "",
      orderIn: "",
      accountName: "",
      salesPersonId: "",
      b2bAccounts: false,
    });
    setSelectedOrderBy(null);
    setSelectedOrderIn(null);
  };

  useEffect(()=>{
    if(didApplyRef.current && isLeadListSuccess){
      didApplyRef.current = false;
      dispatch(setLeadListAction(false));
      // hideHandler();
      setOpenFilter(false);
    }
  },[dispatch, isLeadListSuccess, setOpenFilter]);

    // Create a simple array of unique account names as strings
    const accountNameOptions = useMemo(() => {
      if (!Array.isArray(accountNamesList)) return [];
      return Array.from(new Set(accountNamesList.map(item => item.accountName).filter(Boolean)));
    }, [accountNamesList]);

    const updatedFields = useMemo(() => {
      return filterFields.map((field) => {
        if (field.id === "accountName") {
          return {
            ...field,
            type: "select",
            options: accountNameOptions, // Now a string array
          };
        }else if(field.id === "salesPersonId"){
          const salesUsers = users.map((user: any) => ({
          label: user.name,
          id: user.staff_id ?? user?.tenant_id,
        }));

        return {
          ...field,
          options: [{label:'N/A', id: 'NONE'},...salesUsers],
        };
        }
        return field;
      });
    }, [accountNameOptions, users]);

  const hideHandler=() => {
    onHide();
    setSelectedOrderBy(null);
    setSelectedOrderIn(null);
  }

  return (
    <Popup
      open={open}
      title={title}
      onHide={hideHandler}
      fullWidth={fullWidth}
      maxWidth={maxWidth}
      popupBg="#fff"
      footer={
        <Box sx={{ display: "flex", justifyContent: "flex-end", gap: 2 }}>
          <CustomButton
            style={{ padding: "10px 30px", height: "36px" }}
            variant="outlined"
            title="Clear"
            onClick={clearHandler}
          />
          <CustomButton
            style={{ padding: "10px 30px", height: "36px" }}
            variant="outlined"
            title="Cancel"
            onClick={hideHandler}
          />
          <CustomButton
            style={{ padding: "10px 30px", height: "36px" }}
            title="Apply"
            onClick={submitHandler}
          />
        </Box>
      }
    >
      <Grid
        container
        spacing={2}
        alignItems="center"
        sx={{ marginTop: 3, padding: "0px 8px" }}
      >
        <Grid item xs={12}>
          <FormControlLabel
            control={
              <Switch
                checked={Boolean(filterOption.b2bAccounts)}
                onChange={handleB2BAccountsChange}
              />
            }
            label="B2B Accounts"
          />
        </Grid>
        {updatedFields?.map((field: any) => (
          <Grid item xs={6} key={field.id}>
            <FormField
              onPaste={(e: any) => e.preventDefault()}
              {...{
                ...field,
                value:
                  formData?.[field.id] || "",
                onChange: onChangeAction,
                variant: "outlined",
                isNonMarginTop: true,
                inSingleGridForm: true,
                maxWidth: "100%",
                InputProps: {
                  sx: { padding: "10px 4px", height: "36px" },
                },
              }}
            />
          </Grid>
        ))}
      </Grid>
    </Popup>
  );
};

export default ManageFilter;
